import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

/**
 * Opens the "Set up donation" modal. The panel reads the current donation config from Redux and commits it (enabled)
 * on Save, so no props are needed here.
 */
export const openTicketingDonationModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.TICKETING_DONATION_MODAL,
      panelProps: {},
    })
  );
};
